// FIXME: This file is just an example, please take it as reference to make your own.

import { makeActionCreator } from '../../config/store/utils'

export const UPDATE_NAME_SUCCESS = 'UPDATE_NAME_SUCCESS'
export const onUpdateNameSuccess = makeActionCreator(UPDATE_NAME_SUCCESS, 'payload')
